import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { api } from "@lr-notitia/notitia-engineer/client";
import { graph } from "../modules/information-model/utils/graph";
import { useGraphStore } from "./graph";
import { useDomainStore } from "./domain";
import router from "../router";

let graphStore: ReturnType<typeof useGraphStore>;
let domainStore: ReturnType<typeof useDomainStore>;
function init() {
	graphStore = useGraphStore();
	domainStore = useDomainStore();
}

export const useViewsStore = defineStore("views", () => {
	const nodePositions = ref<{ [viewId: string]: { [nodeId: string]: { x: number; y: number } } }>({});

	const openedViewId = ref<string | undefined>(undefined);
	const openedView = computed(() => {
		if (!graphStore) init();
		if (!openedViewId.value) return undefined;
		return graphStore.concept.view.byId(openedViewId.value);
	});
	const viewGraph = computed(() => graph(openedViewId.value || ""));

	function getNodePositions(viewId: string) {
		if (!viewId) return;
		if (!graphStore) init();
		graphStore.concept.dataobjects.forEach((concept) => {
			if (!concept.context) concept.context = {};
			if (!concept.context["nta-pos"]) concept.context["nta-pos"] = {};
			if (!concept.context["nta-pos"][viewId]) concept.context["nta-pos"][viewId] = {};
			const pos = concept.context["nta-pos"][viewId];
			if (!nodePositions.value[viewId]) nodePositions.value[viewId] = {};
			nodePositions.value[viewId][concept.id] = {
				x: pos?.x || 0,
				y: pos?.y || 0,
			};
		});
	}

	watch(
		() => openedViewId.value,
		(newId, oldId) => {
			if (!domainStore || !graphStore) init();
			const domainId = router.currentRoute.value.params.domainId as string;
			if (oldId) {
				api().socket().domain(domainId).infmodel().view(oldId).off();
				api()
					.socket()
					.domain(domainId)
					.infmodel()
					.view(openedViewId.value || "")
					.livePosition()
					.off();
			}
			if (newId) {
				api()
					.socket()
					.domain(domainId)
					.infmodel()
					.view(openedViewId.value || "")
					.livePosition()
					.on((pos) => {
						nodePositions.value[newId] = pos;
					});
			}
		}
	);

	return {
		openedViewId,
		openedView,
		viewGraph,
		getNodePositions,
		nodePositions,
	};
});
